import React from "react";

export default function EngineeredFeatures() {
  return (
    <section className="vf">
      <div className="vf-wrap">
        <div className="vf-top">
          <div>
            <div className="vf-eyebrow">Feature Highlights</div>
            <h2 className="vf-h2 section-title">
              Everything You Need in a <br />
              <span>DC Charger</span> - Without the Bulk
            </h2>
          </div>
        </div>

        <div className="vf-bento">
          {/* CELL 1 — Compact Footprint */}
          <div className="vf-cell c1 tall">
            <div>
              <div className="vf-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
                </svg>
              </div>
              <div className="vf-title">Compact Footprint</div>
              <p className="vf-desc">
                Minimal space requirement without compromising charging
                performance — fits where larger units simply can't go.
              </p>
            </div>
          </div>

          {/* CELL 2 — Smart Connectivity */}
          <div className="vf-cell c2">
            <div className="vf-icon">
              <svg viewBox="0 0 24 24">
                <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                <path d="M1.42 9a16 16 0 0 1 21.16 0" />
                <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
                <circle cx="12" cy="20" r="1" fill="#007a40" />
              </svg>
            </div>
            <div className="vf-title">Smart Connectivity</div>
            <p className="vf-desc" style={{ maxWidth: 320 }}>
              Supports Ethernet, Wi-Fi, and GSM / 4G connectivity for seamless charger communication and remote monitoring. 
 
            </p>
            <div style={{ display: "flex", gap: 8, marginTop: 20, flexWrap: "wrap" }}>
              <span className="chip">Ethernet</span>
              <span className="chip">Wi-Fi</span>
              <span className="chip">GSM / 4G</span>
              <span className="chip">Bluetooth</span>
            </div>
          </div>

          {/* CELL 3 — OCPP */}
          <div className="vf-cell c3">
            <div className="vf-icon">
              <svg viewBox="0 0 24 24">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
              </svg>
            </div>
            <div className="vf-title">OCPP Compliant</div>
            <p className="vf-desc">
              Integrates with any CMS or roaming platform. Upgradable to 2.1
              via OTA — no hardware changes.
            </p>
            <div className="vf-pill" style={{ marginTop: 20 }}>
              OCPP 1.6J → 2.1
            </div>
          </div>

          {/* CELL 4 — High Uptime */}
          <div className="vf-cell c4">
            <div className="vf-icon">
              <svg viewBox="0 0 24 24">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </div>
            <div className="vf-title">High Operational Uptime</div>
            <p className="vf-desc">
              Industrial-grade architecture for dependable long-duration
              operations — 24/7, every day.
            </p>
            <div style={{ marginTop: 20 }}>
              <div className="uptime-num">99.2%</div>
              <div style={{ fontSize: 11, color: "rgba(0,40,20,0.5)", marginTop: 2 }}>
                Network uptime
              </div>
            </div>
          </div>

          {/* CELL 5 — Remote Monitoring */}
          <div className="vf-cell c5">
            <div className="vf-icon">
              <svg viewBox="0 0 24 24">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
              </svg>
            </div>
            <div className="vf-title">Remote Monitoring &amp; Diagnostics</div>
            <p className="vf-desc">
              Live charger health, sessions, alerts, and firmware updates — all
              managed remotely with zero site visits.
            </p>
          </div>

          {/* CELL 6 — India */}
          <div className="vf-cell c6 wide">
            <div className="vf-cell-body">
              <div className="vf-icon">
                <svg viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M2 12h20" />
                  <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                </svg>
              </div>
              <div className="vf-title">Built for Indian Conditions</div>
              <p className="vf-desc" style={{ maxWidth: 560 }}>
                Reliable performance across heat, dust, humidity, and demanding
                outdoor environments.
              </p>
            </div>
            <div className="wide-divider"></div>
            <div className="vf-cell-stat">
              <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                <div>
                  <div className="wide vf-stat-num">IP55</div>
                  <div className="wide vf-stat-label">Weatherproof Rating</div>
                </div>
                <div style={{ width: "100%", height: 1, background: "rgba(0,60,30,0.12)" }}></div>
                <div>
                  <div className="wide vf-stat-num">55°C</div>
                  <div className="wide vf-stat-label">Max Operating Temp</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
